<template>
    <component :is="tag" class="module-vacation" v-bind="appContentProperties">
        <loading-indicator v-if="loading"/>
        <div v-else class="vacation-calendar-outer-wrapper">
            <div class="vacation-calendar-wrapper" :class="fullscreenActive ? 'fullscreen' : ''">
                <template v-if="!isAppContent">
                    <div class="row">
                        <div :class="showExplanation ? 'col-lg-9' : 'col-lg-12'">
                            <h2 v-if="showRegulationTitle && regulationId"
                                class="no-margin">{{regulations[regulationId].title}} (benötigte Mitarbeiter: {{regulations[regulationId].required_employees}})</h2>
                        </div>
                        <div v-if="showExplanation" class="col-lg-3 text-right">
                            <app-popover :close-on-scroll="false" :inherit-width="true" position="bottom">
                                <template #default="{toggle, close, open}">
                                    <button @click="toggle" class="button button-default" type="button">
                                        <i class="material-icons md-16" aria-hidden="true" role="img">info</i><span>Legende</span>
                                    </button>
                                </template>
                                <template #container>
                                    <portuna-box class="no-padding no-margin">
                                        <table class="portuna-table portuna-table-bordered">
                                            <colgroup>
                                                <col style="width: 60px;"/>
                                                <col/>
                                            </colgroup>
                                            <tbody>
                                            <tr>
                                                <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">flight_takeoff</i></td>
                                                <td>Urlaub</td>
                                            </tr>
                                            <tr>
                                                <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">block</i></td>
                                                <td>Sonstiges</td>
                                            </tr>
                                            <tr>
                                                <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">school</i></td>
                                                <td>Berufsschule</td>
                                            </tr>
                                            <tr>
                                                <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">public</i></td>
                                                <td>Feiertag</td>
                                            </tr>
                                            <tr>
                                                <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">local_hospital</i></td>
                                                <td>Krank</td>
                                            </tr>
                                            <tr>
                                                <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">clear</i></td>
                                                <td>Nicht eingestellt</td>
                                            </tr>
                                            <tr>
                                                <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">access_time</i></td>
                                                <td>Stundenabbau</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </portuna-box>
                                </template>
                            </app-popover>
                        </div>
                    </div>
                    <slot name="navigation"/>
                </template>
                <template v-else>
                    <div>
                        <slot name="navigation">
                            <div :class="{'flex flex-space-between': viewSize.xlUp}">
                                <div v-if="isAllowedEdit || isAllowedRequest" class="button-row button-row-fixed">
                                    <button v-if="isAllowedEdit" v-interact="newAbsence" class="button button-add button-block margin-bottom-10" type="button"
                                        style="max-width: 300px;">
                                        <i class="material-icons" aria-hidden="true" role="img">add</i>
                                        <span>Abwesenheit hinzufügen</span>
                                    </button>
                                    <button v-if="isAllowedRequest" v-interact="requestAbsence" class="button button-add button-block margin-bottom-10" type="button"
                                        style="max-width: 300px;">
                                        <i class="material-icons" aria-hidden="true" role="img">add</i>
                                        <span>Abwesenheit beantragen</span>
                                    </button>
                                </div>
                                <div v-else/>
                                <div class="button-row button-row-fixed">
                                    <button v-if="isAppContent" v-interact="() => generateListLink()" class="button button-primary no-wrap" :class="{disabled: searchIsEmpty}"
                                        title="Generiert einen Link zur Liste mit den aktuellen Such- und Filtereinstellungen">
                                        <i aria-hidden="true" class="material-icons md-18" role="img">link</i>
                                        <span>Link kopieren</span>
                                    </button>
                                    <router-link :to="{name: 'absence-calendar', params: {year: prevYear}}" class="button button-primary">
                                        <i class="material-icons" aria-hidden="true" role="img">chevron_left</i>
                                        <span>Jahr {{prevYear}}</span>
                                    </router-link>

                                    <span class="button button-default cursor-default">
                                            Aktuell: {{year}}
                                        </span>

                                    <router-link :to="{name: 'absence-calendar', params: {year: nextYear}}" class="button button-primary">
                                        Jahr {{nextYear}}
                                        <i class="material-icons" aria-hidden="true" role="img">chevron_right</i>
                                    </router-link>

                                    <app-popover :close-on-scroll="false" position="bottom">
                                        <template #default="{toggle, close, open}">
                                            <button @click="toggle" class="button button-default" type="button">
                                                <i class="material-icons md-16" aria-hidden="true" role="img">info</i><span>Legende</span>
                                            </button>
                                        </template>
                                        <template #container>
                                            <portuna-box class="no-padding no-margin">
                                                <table class="portuna-table portuna-table-bordered width-auto">
                                                    <colgroup>
                                                        <col style="width: 60px;"/>
                                                        <col style="width: 400px;"/>
                                                    </colgroup>
                                                    <tbody>
                                                    <tr>
                                                        <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">flight_takeoff</i></td>
                                                        <td>Urlaub</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">block</i></td>
                                                        <td>Sonstiges</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">school</i></td>
                                                        <td>Berufsschule</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">public</i></td>
                                                        <td>Feiertag</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">local_hospital</i></td>
                                                        <td>Krank</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">clear</i></td>
                                                        <td>Nicht eingestellt</td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-center"><i class="material-icons" aria-hidden="true" role="img">access_time</i></td>
                                                        <td>Stundenabbau</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </portuna-box>
                                        </template>
                                    </app-popover>
                                </div>
                            </div>
                        </slot>
                    </div>

                    <div v-if="searchable" class="row">
                        <div :class="hasClient ? 'col-lg-2' : 'col-lg-3'">
                            <label>
                                Mitarbeiter:
                                <form-select class="spacer-5" v-model="search.employees" :options="employeeNames" multiple/>
                            </label>

                            <div class="spacer spacer-10 hidden-lg-upward"/>
                        </div>

                        <div :class="hasClient ? 'col-lg-2' : 'col-lg-3'">
                            <label>
                                Abteilung:
                                <form-select class="spacer-5" v-model="search.entities" :options="entities" multiple/>
                            </label>

                            <div class="spacer spacer-10 hidden-lg-upward"/>
                        </div>

                        <div class="col-lg-2">
                            <label>
                                Vertretungsregelungen:
                                <form-select class="spacer-5" v-model="search.regulations" :options="regulationOptions" multiple/>
                            </label>

                            <div class="spacer spacer-10 hidden-lg-upward"/>
                        </div>

                        <div v-if="hasClient" class="col-lg-2">
                            <label>
                                Mandant:
                                <form-select class="spacer-5" v-model="search.client_id" :options="clients" multiple/>
                            </label>

                            <div class="spacer spacer-10 hidden-lg-upward"/>
                        </div>

                        <div class="col-lg-2">
                            <label>
                                <span>Beschäftigungsart (aktuell):</span>
                                <form-select class="spacer-5" v-model.number="search.work_state" :options="workStateOptions"/>
                            </label>

                            <div class="spacer spacer-10 hidden-lg-upward"/>
                        </div>

                        <div class="col-lg-2">
                            <label>
                                <span>Status:</span>
                                <span v-if="search.employed === filterStateEmployed && year < currentYear"
                                    class="label label-warning small">Achtung: Vergangenes Jahr ausgewählt!</span>
                                <form-select class="spacer-5" v-model.number="search.employed" :options="employmentOptions"/>
                            </label>

                            <div class="spacer spacer-10 hidden-lg-upward"/>
                        </div>
                    </div>
                </template>

                <div v-if="reload" class="margin-top-15 padding-10" style="border: 1px solid #cccccc;">
                    <loading-indicator></loading-indicator>
                </div>
                <div v-else-if="listEmployees.length" class="absence-calendar-wrapper spacer-15">
                    <table class="vacation-calendar-table-left flex--width-auto">
                        <thead>
                        <tr>
                            <td>
                                <span v-interact="toggleFullscreen" :aria-label="`Vollbild${fullscreenActive ? ' beenden' : ''}`" class="icon-interact">
                                    <i :title="`Vollbild${fullscreenActive ? ' beenden' : ''}`" aria-hidden="true" class="material-icons" role="img">
                                    fullscreen{{fullscreenActive ? '_exit' : ''}}
                                </i>
                                </span>
                            </td>
                        </tr>
                        <tr :style="{height: calendarWeekHeight + 'px'}">
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="employee in listEmployees" :class="{'selected': ~~employee.id === collisionEmployee}">
                            <td class="text-overflow" :title="employee.name">
                                <router-link :to="{name: 'employee-view', params: {id: employee.id}}">{{employee.name}}</router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <div class="absence-calendar-right">
                        <div ref="calendarRightHead" class="vacation-calendar-table-head-clone" v-sticky="{position: 'top'}">
                            <table class="vacation-calendar-table absence-calendar-table" border="1">
                                <thead>
                                <tr>
                                    <td v-for="(month, index) of months"
                                        :class="['vacation-calendar-month', {'vacation-calendar-border-left': 0 !== index, 'current-month': year === currentYear && month.number === currentMonth}]"
                                        :colspan="month.days">{{month.name}}
                                    </td>
                                </tr>
                                <tr>
                                    <td v-for="monday of buildCalendarWeeks(days)" class="vacation-calendar-border-left" :colspan="monday.colspan">
                                        KW {{monday.number}}
                                    </td>
                                </tr>
                                <tr>
                                    <td v-for="day of days" :class="[`day-${day.day}`, {'vacation-calendar-border-left': day.border}]">{{day.name}}</td>
                                </tr>
                                <tr>
                                    <td v-for="day of days" :class="[`day-${day.day}`, {'vacation-calendar-border-left': day.border}]">{{day.number}}</td>
                                </tr>
                                </thead>
                            </table>
                        </div>

                        <div ref="calendarRight" class="vacation-calendar-right" :style="'margin-top: ' + calendarRightMarginTop + 'px'" @scroll="updateTableHead">
                            <table class="vacation-calendar-table absence-calendar-table" border="1">
                                <thead>
                                <tr>
                                    <td v-for="(month, index) of months"
                                        :class="['vacation-calendar-month', {'vacation-calendar-border-left': 0 !== index, 'current-month': year === currentYear && month.number === currentMonth}]"
                                        :colspan="month.days">{{month.name}}
                                    </td>
                                </tr>
                                <tr ref="calendarWeekTableRow">
                                    <td v-for="monday of buildCalendarWeeks(days)" class="vacation-calendar-border-left" :colspan="monday.colspan">
                                        KW {{monday.number}}
                                    </td>
                                </tr>
                                <tr>
                                    <td v-for="day of days" :class="[`day-${day.day}`, {'vacation-calendar-border-left': day.border}]">{{day.name}}</td>
                                </tr>
                                <tr>
                                    <td v-for="day of days" :class="[`day-${day.day}`, {'vacation-calendar-border-left': day.border}]">{{day.number}}</td>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="employee of listEmployees" :class="{'selected': !collisionEmployee && isCurrentEmployee(employee.id)}">
                                    <td v-for="day of days"
                                        :class="[`day-${day.day} cursor-default`, getState(employee.id, day.date), {'vacation-calendar-border-left': day.border, selectedDay: day.date === currentDate}]"
                                        :title="entries[employee.id] && entries[employee.id][day.date] && icons[entries[employee.id][day.date]] ? icons[entries[employee.id][day.date]].label : ''">
                                        <i v-if="entries[employee.id] && entries[employee.id][day.date]" class="material-icons md-16" aria-hidden="true" role="img">{{
                                                icons[entries[employee.id][day.date]]
                                                    ? icons[entries[employee.id][day.date]].icon
                                                    : ''
                                            }}</i>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div v-else class="start-page-container text-center spacer-15" style="border: 1px solid #cccccc;">
                    <div>
                        <i class="material-icons start-page-icon" aria-hidden="true" role="img">event</i>

                        <div class="start-page-title">Abwesenheiten</div>
                        <div class="start-page-description">
                            <div v-if="searchIsEmpty">
                                Wählen Sie zunächst aus den obigen Filtern, um die
                                <br>
                                Abwesenheiten der jeweiligen Mitarbeiter anzeigen zu lassen.
                            </div>
                            <div v-else>
                                Es konnten keine Mitarbeiter zum aktiven Filter gefunden werden.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </component>
</template>

<script lang="ts">
    import CopyLinkPopup from '@/components/CopyLinkPopup.vue';
    import {setToMonday} from '@/library/date';
    import {WORK_STATE_OPTIONS, WORK_STATES} from '@/library/modules/employee';
    import {Popup} from '@/library/popup';
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator';
    import {Getter} from 'vuex-facing-decorator';
    import AppContent from '../../components/AppContent.vue';
    import AppPopover from '../../components/AppPopover.vue';
    import FormSelect from '../../components/form/FormSelect.vue';
    import LoadingIndicator from '../../components/LoadingIndicator.vue';
    import PortunaBox from '../../components/PortunaBox.vue';
    import {orderBy} from '@/library/filter';
    import {absencePopUp, requestAbsencePopUp} from '@/library/modules/absences/absences';
    import {getEmployeeBasicBreadcrumb} from '@/library/modules/employee/employee';
    import {base64UrlEncode, errorHandler} from '@/utils/portuna';
    import dateHelper from '../../utils/portuna/dateHelper';

    const FILTER_STATE_EMPLOYED = 1;
    const FILTER_STATE_ALL      = 2;

    type AbsenceSearchDefinition = {
        employees: number[];
        entities: number[];
        regulations: number[];
        employed: number;
        work_state: string[];
        client_id: number[];
    };
    @Component({
        name: 'AbsenceCalendar',
        components: {
            AppContent,
            PortunaBox,
            AppPopover,
            FormSelect,
            LoadingIndicator,
        },
    })
    export default class AbsenceCalendar extends Vue
    {
        readonly $refs: {
            calendarRight: HTMLDivElement
            calendarRightHead: HTMLDivElement
            calendarWeekTableRow: HTMLDivElement
        };

        @Getter('hasClient') hasClient: boolean;

        @Prop({
            type: Object,
            default: () =>
            {
                return {};
            },
        }) filter: AbsenceSearchDefinition;

        @Prop({
            type: Number,
            required: true,
        }) year: number;

        @Prop({
            type: Number,
            default: 0,
            required: false,
        }) vacationRequestId: number;

        @Prop({
            type: Number,
            default: 0,
            required: false,
        }) regulationId: number;

        @Prop({
            type: Number,
            default: 0,
            required: false,
        }) ovrId: number;

        @Prop({
            type: Number,
            default: 0,
            required: false,
        }) absenceId: number;

        @Prop({
            type: String,
            default: 'AppContent',
            required: false,
        }) tag: string;

        @Prop({
            type: Boolean,
            default: true,
            required: false,
        }) displayNavigation: boolean;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) showRegulationTitle: boolean;

        @Prop({
            type: Boolean,
            default: true,
            required: false,
        }) showExplanation: boolean;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) showPlanning: boolean;

        breadcrumb: Breadcrumb[] = [
            getEmployeeBasicBreadcrumb(),
        ];

        collisionEmployee: number = 0;

        days: AbsencesCalendarDay[] = [];

        entries: Record<number, Record<string, string>> = {};

        employees: { id: number; name: string; surname: string; work_state: string; client_id: number; }[] = [];

        entities: SelectOption[] = [];

        clients: SelectOption[] = [];

        entitiesEmployees: Record<string, number[]> = {};

        regulations: Record<string, VacationStatisticRegulationEntry> = {};

        fullscreenActive: boolean = false;

        employeesEmployed: number[] = [];

        searchable: boolean = false;

        filterStateEmployed = FILTER_STATE_EMPLOYED;

        icons: Record<string, AbsencesCalendarIcon> = {
            f: {
                icon: 'clear',
                label: 'Nicht eingestellt',
            },
            u: {
                icon: 'flight_takeoff',
                label: 'Urlaub',
            },
            a: {
                icon: 'block',
                label: 'Sonstiges',
            },
            s: {
                icon: 'school',
                label: 'Berufsschule',
            },
            h: {
                icon: 'public',
                label: 'Feiertag',
            },
            n: {
                icon: 'local_hospital',
                label: 'Krank',
            },
            o: {
                icon: 'minimize',
                label: 'Kein Arbeitstag',
            },
            b: {
                icon: 'flight_takeoff',
                label: 'Betriebsferien',
            },
            // time-tracker
            t: {
                icon: 'access_time',
                label: 'Stundenabbau',
            },
            p: {
                icon: 'access_time',
                label: 'Zeitplanung (Abwesend)',
            },
        };

        employmentOptions = {
            [FILTER_STATE_EMPLOYED]: 'Derzeit angestellt',
            [FILTER_STATE_ALL]: 'Alle Mitarbeiter',
        };

        workStateOptions = WORK_STATE_OPTIONS.filter(option => option.value !== WORK_STATES.end.value);

        months: AbsencesCalendarMonth[] = [];

        loading: boolean = true;

        reload: boolean = false;

        search: AbsenceSearchDefinition = {
            employees: [],
            entities: [],
            regulations: [],
            employed: FILTER_STATE_EMPLOYED,
            work_state: [],
            client_id: [],
        };

        scrolled: boolean = false;

        calendarRightMarginTop = 0;

        calendarWeekHeight = 26;

        previousScrollPosition = 0;

        isAllowedEdit = false;

        isAllowedRequest: boolean = false;

        get employeeNames(): SelectOption[]
        {
            let options = [];

            for (const employee of this.employees)
            {
                options.push({
                    value: employee.id,
                    label: employee.name + ' ' + employee.surname,
                });
            }

            return options;
        }

        get fetchUrl()
        {
            let url = '/employee/absences-statistic/fetch-calendar-list';

            url += `/year/${this.year}`;

            if (this.vacationRequestId)
            {
                url += `/vr_id/${this.vacationRequestId}`;
            }

            if (this.regulationId)
            {
                url += `/regulation_id/${this.regulationId}`;
            }

            if (this.ovrId)
            {
                url += `/ovr_id/${this.ovrId}`;
            }

            if (this.absenceId)
            {
                url += `/absence_id/${this.absenceId}`;
            }

            if (this.showPlanning)
            {
                url += `/planning/${this.showPlanning ? 1 : 0}`;
            }

            return url;
        }

        get isAppContent()
        {
            return 'AppContent' === this.tag;
        }

        get appContentProperties()
        {
            return this.isAppContent ? {
                headline: 'Abwesenheitskalender',
                breadcrumb: this.breadcrumb,
            } : {};
        }

        get regulationOptions()
        {
            let options: SelectOption[] = [];

            for (let id in this.regulations)
            {
                if (this.regulations.hasOwnProperty(id))
                {
                    options.push({
                        value: id,
                        label: this.regulations[id].title,
                    });
                }
            }

            return orderBy(options, 'label', 'asc');
        }

        get searchIsEmpty()
        {
            return this.isAppContent && !this.search.employees.length && !this.search.entities.length && !this.search.regulations.length && !this.search.work_state.length;
        }

        get listEmployees()
        {
            let employees: { name: string; id: number }[] = [];

            let entitiesSearchEmployees: number[] = [];
            for (let entity of this.search.entities)
            {
                this.entitiesEmployees[entity] && entitiesSearchEmployees.push(...this.entitiesEmployees[entity]);
            }

            let regulationSearchEmployees: number[] = [];
            for (let regulation of this.search.regulations)
            {
                regulationSearchEmployees.push(...this.regulations[regulation].employees);
            }

            if (this.searchIsEmpty)
            {
                return [];
            }

            let checkEmployees   = 0 !== this.search.employees.length;
            let checkEntities    = 0 !== this.search.entities.length;
            let checkRegulations = 0 !== this.search.regulations.length;
            let checkWorkState   = 0 !== this.search.work_state.length;
            let checkClient      = this.hasClient && 0 !== this.search.client_id.length;
            let checkEmployed    = this.isAppContent && FILTER_STATE_ALL !== this.search.employed;

            for (const employee of this.employees)
            {
                // employee check
                if (checkEmployees && !this.search.employees.includes(employee.id))
                {
                    continue;
                }
                // work_state check
                if (checkWorkState && !this.search.work_state.includes(employee.work_state))
                {
                    continue;
                }
                // client check
                if (checkClient && !this.search.client_id.includes(employee.client_id || -1))
                {
                    continue;
                }
                // entity check
                if (checkEntities && !entitiesSearchEmployees.includes(employee.id))
                {
                    continue;
                }
                // regulation check
                if (checkRegulations && !regulationSearchEmployees.includes(employee.id))
                {
                    continue;
                }
                // employment check
                if (checkEmployed && !this.employeesEmployed.includes(employee.id))
                {
                    continue;
                }

                employees.push({
                    id: employee.id,
                    name: employee.surname + ', ' + employee.name,
                });
            }

            return employees;
        }

        get currentYear()
        {
            return dateHelper('Y') as number;
        }

        get currentMonth()
        {
            return dateHelper('n') as number;
        }

        get currentDate()
        {
            return dateHelper('Y-m-d');
        }

        get prevYear()
        {
            return this.year - 1;
        }

        get nextYear()
        {
            return this.year + 1;
        }

        get relativeLink()
        {
            let relativeLink = this.$router.resolve({
                name: 'absence-calendar',
            }).href;

            return relativeLink + '/' + this.year + '/' + base64UrlEncode(JSON.stringify(Object.assign({}, this.search)));
        }

        @Watch('year')
        @Watch('regulationId')
        watchProps()
        {
            this.loading          = true;
            this.scrolled         = false;
            this.fullscreenActive = false;
            this.fetch();
        }

        @Watch('searchIsEmpty')
        watchSearchIsEmpty()
        {
            this.$nextTick(() =>
            {
                let calendarRight = this.$refs.calendarRight;

                if (calendarRight)
                {
                    calendarRight.scrollLeft = this.previousScrollPosition;
                }
            });
        }

        @Watch('loading')
        @Watch('search', {deep: true})
        updated()
        {
            if (!this.searchIsEmpty && this.isAppContent)
            {
                this.$router.replace(this.relativeLink);
            }

            if (this.scrolled)
            {
                return;
            }

            window.setTimeout(() =>
            {
                const calendarRight        = this.$refs.calendarRight;
                const calendarWeekTableRow = this.$refs.calendarWeekTableRow;

                if (!this.loading)
                {
                    if (calendarRight)
                    {
                        let width   = 0;
                        let scroll  = false;
                        let matches = calendarRight.querySelectorAll('thead > tr > td.vacation-calendar-month') as NodeListOf<HTMLTableDataCellElement>;

                        for (let el of matches)
                        {
                            if (el.classList.contains('current-month'))
                            {
                                scroll = true;
                                break;
                            }

                            width += el.offsetWidth;
                        }

                        if (scroll)
                        {
                            if (calendarRight.scroll)
                            {
                                calendarRight.scroll({
                                    left: width,
                                    behavior: 'smooth',
                                });
                            }
                            else
                            {
                                calendarRight.scrollLeft = width;
                            }
                        }

                        this.calendarRightMarginTop = -(calendarRight.querySelector('thead')?.clientHeight || 0);

                        this.scrolled = true;
                    }

                    if (calendarWeekTableRow)
                    {
                        this.calendarWeekHeight = calendarWeekTableRow.clientHeight || 26;
                    }
                }
            }, 0);
        }

        created()
        {
            this.fetch();
            this.search = Object.assign(this.search, this.filter);
        }

        fetch()
        {
            this.loading = !this.reload;
            return (this.isAppContent ? this.$store.dispatch(
                'getPage',
                {
                    url: this.fetchUrl,
                    setLoading: false,
                },
            ) : this.axios.get(this.fetchUrl))
            .then(({data: {data: r}}) =>
            {
                this.collisionEmployee = r.collisionEmployee;
                this.days              = r.days;
                this.employees         = r.employees;
                this.entries           = r.entries;
                this.months            = r.months;
                this.entities          = r.entities;
                this.entitiesEmployees = r.entitiesEmployees;
                this.clients           = r.clients;
                this.regulations       = r.regulations;
                this.searchable        = r.searchable;
                this.employeesEmployed = r.employeesEmployed;
                this.isAllowedEdit     = r.isAllowedEdit;
                this.isAllowedRequest  = r.isAllowedRequest;
                this.loading           = false;
            })
            .catch((err) =>
            {
                console.error(err);
                errorHandler(err);
                this.isAppContent && this.routerGoBack();
            });
        }

        buildCalendarWeeks(days: AbsencesCalendarDay[])
        {
            const entries = days.filter(day => day.name === 'Mo').map(day =>
            {
                return {
                    colspan: 7,
                    number: this.getWeekNumber(new Date(day.date)),
                };
            });

            if (days[0].name !== 'Mo')
            {
                const date = new Date(days[0].date);

                const colSpans = {
                    0: 1,
                    1: 7,
                    2: 6,
                    3: 5,
                    4: 4,
                    5: 3,
                    6: 2,
                    7: 1,
                };

                entries.unshift({
                    colspan: colSpans[date.getDay()],
                    number: this.getWeekNumber(date),
                });
            }

            const lastIndex = days.length - 1;
            if (days[lastIndex].name !== 'So')
            {
                const date = new Date(days[lastIndex].date);

                entries[entries.length - 1] = {
                    colspan: date.getDay() === 0 ? 7 : date.getDay(),
                    number: this.getWeekNumber(setToMonday(date)),
                };
            }

            return entries;
        }

        getWeekNumber(date: Date): string
        {
            return dateHelper('W', date) as string;
        }

        updateTableHead()
        {
            this.previousScrollPosition             = this.$refs.calendarRight.scrollLeft;
            this.$refs.calendarRightHead.scrollLeft = this.previousScrollPosition;
        }

        generateListLink()
        {
            let popup = new Popup({
                title: `Link zur aktuellen Liste kopieren`,
                titleIcon: 'link',
                size: 'medium',
                component: CopyLinkPopup,
                componentProps: {
                    link: window.location.origin + this.relativeLink,
                },
            });

            popup.open();
        }

        async newAbsence()
        {
            const popup = await absencePopUp(0, false, () =>
            {
                popup.close();

                this.reload = true;
                this.fetch().then(() =>
                {
                    this.reload = false;

                    this.$nextTick(() =>
                    {
                        let calendarRight = this.$refs.calendarRight;

                        if (calendarRight)
                        {
                            calendarRight.scrollLeft = this.previousScrollPosition;
                        }
                    });
                });
            });
        }

        async requestAbsence()
        {
            const popup = await requestAbsencePopUp(() =>
            {
                popup.close();

                this.reload = true;
                this.fetch().then(() =>
                {
                    this.reload = false;

                    this.$nextTick(() =>
                    {
                        let calendarRight = this.$refs.calendarRight;

                        if (calendarRight)
                        {
                            calendarRight.scrollLeft = this.previousScrollPosition;
                        }
                    });
                });
            });
        }

        toggleFullscreen()
        {
            this.fullscreenActive = !this.fullscreenActive;
        }

        isCurrentEmployee(employeeId: string)
        {
            return parseInt(employeeId) === this.currentUser.employeeId;
        }

        getState(employeeId: string, date: string)
        {
            if (this.entries[employeeId] && this.entries[employeeId][date])
            {
                if (typeof this.entries[employeeId][date] === 'string')
                {
                    return 'has-state state-3';
                }

                return 'has-state state-' + this.entries[employeeId][date];
            }

            return '';
        }
    }
</script>